module.exports = __webpack_public_path__ + "img/1493724623.70c58ebc.jpg";